import Loadable from 'react-loadable';

import { LoadingPage } from 'src/components/react-loadable';

const PipelinesWorkspaceAgenticPipelinesPageLoadable = Loadable<any, never>({
  loading: LoadingPage,
  loader: () => import('./agentic-pipelines'),
});

// eslint-disable-next-line import/no-default-export
export default PipelinesWorkspaceAgenticPipelinesPageLoadable;
